import styled from "styled-components/macro";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

export const HeaderIcon = styled.img<{ width: string }>`
  width: ${({ width }) => width};
  margin: auto;
  height: inherit;
`;

export const MobileMenuToggleIcon = styled(HeaderIcon)`
  filter: brightness(0) invert(1);
  cursor: pointer;
`;

export const ActiveHeader = styled.div`
  color: red;
`;

export const HeaderContainer = styled.div`
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.11);
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  height: 90px;
  background: ${({ theme }) => theme.headerBackground};
`;

export const HeaderIconsLinksContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 50px 0 60px;
`;

export const HeaderIconsContainer = styled.div<{ paddingLeft?: number }>`
  display: flex;
  align-items: center;
`;

export const HeaderLockupImg = styled.img`
  display: block;
  height: 30px;
  width: auto;
`;

export const HeaderLinksContainer = styled.div<{ onlyLogin: boolean }>`
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 32px;

  a:hover p {
    color: ${({ theme }) => theme.tealAccent} !important;
  }
`;

export const HeaderNavButton = styled.button<{ $active: boolean }>`
  background: transparent;
  border: 0;
  margin: 0;
  padding: 0;
  text-align: left;
  text-decoration: ${({ $active }) => ($active ? "underline" : "none")};
  cursor: pointer;

  &:hover p {
    color: ${({ theme }) => theme.greenDark};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.tealAccent};
    outline-offset: 3px;
  }
`;

export const HeaderActionDivider = styled.div`
  width: 1px;
  height: 18px;
  background: ${({ theme }) => theme.white};
  opacity: 0.8;
`;

export const HeaderIconButton = styled.button<{
  $active?: boolean;
  $svgSize?: string;
}>`
  border: 1px solid ${({ theme }) => theme.white};
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  color: ${({ $active, theme }) =>
    $active ? theme.headerBackground : theme.white};
  background: ${({ $active, theme }) =>
    $active ? theme.white : "transparent"};
  cursor: pointer;

  svg {
    display: block;
    width: ${({ $svgSize }) => $svgSize ?? "12px"};
    height: ${({ $svgSize }) => $svgSize ?? "12px"};
    color: currentColor;
  }

  &:hover {
    border-color: ${({ theme }) => theme.white};
    color: ${({ $active, theme }) =>
      $active ? theme.headerBackground : theme.white};
    background: ${({ $active, theme }) =>
      $active ? theme.white : "rgba(255, 255, 255, 0.12)"};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.tealAccent};
    outline-offset: 2px;
  }
`;

export const FeedbackIconButton = styled(HeaderIconButton)`
  border: 0;
  color: ${({ $active, theme }) =>
    $active ? theme.headerBackground : theme.white};
  background: ${({ $active, theme }) =>
    $active ? theme.white : "transparent"};

  &:hover {
    border-color: ${({ theme }) => theme.white};
    color: ${({ $active, theme }) =>
      $active ? theme.headerBackground : theme.white};
    background: ${({ $active, theme }) =>
      $active ? theme.white : "rgba(255, 255, 255, 0.12)"};
  }
`;

export const HeaderContainerMobile = styled.div`
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.11);
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  height: 63px;
  background: ${({ theme }) => theme.headerBackground};
`;

export const HeaderIconContainerMobile = styled.div`
  display: grid;
  grid-template-columns: 1fr min-content;
  align-items: center;
  height: 100%;
  padding-left: 20px;
`;

export const HeaderIconContainerMobileWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderIconContainerMobileGrid = styled.div<{
  deviceType: DeviceType;
}>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: ${({ deviceType }) =>
    deviceType === "mobile" ? "15px" : "30px"};
`;

export const FeedbackBannerContainer = styled.div`
  margin: 16px 16px 0 16px;
`;
